import type { Currency } from "adl-gen/ferovinum/app/db";

export class FeroCurrencyUtils {
  public static currencyCodeToSymbol(currency: Currency) {
    switch (currency) {
      case "GBP":
        return "£";
      case "USD":
      case "AUD":
      case "NZD":
      case "CAD":
      case "MXN":
      case "HKD":
      case "TWD":
        return "$";
      case "EUR":
        return "€";
      case "JPY":
        return "¥";
      case "CHF":
        return "CHF";
      case "DKK":
        return "kr";
      case "SEK":
        return "kr";
      case "NOK":
        return "kr";
      case "BRL":
        return "R$";
      case "ARS":
        return "AR$";
      case "KRW":
        return "₩";
      case "INR":
        return "₹";
      case "AED":
        return "AED";
      case "ZAR":
        return "R";
      default:
        return "";
    }
  }
}
